module.exports = "<p>\r\n  parts works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/parts/parts.component.html
// module id = ./src/app/pages/parts/parts.component.html
// module chunks = main